import './NewName.css';
import { useState, useEffect } from 'react';
import { MdKeyboardDoubleArrowRight, MdKeyboardDoubleArrowLeft } from 'react-icons/md';
import regx from '../../../functions/regx';
import Main from './Main';
import Close from '../../design/close';
import IconDiv from '../../design/IconDiv';
import Massage from '../../design/Massage';
import {insertNewUser, updateUser, deleteNames, check_change} from "./insertUser";
import FetchMassage from '../../../faetures/FetchMassage';
import re from '../../../functions/regx';


export default function NewName ({
    names, // all user datalist
    setNames, // add or update names
    numOfUser, // num of user, if 0 is new
    setNumOfUser, setClose, numOfDocket, setNamesSearch, deleteNamesInClient}) {
        
    const templateUser = {firstName: '', lastName: '', fnh: '', lnh: '', id : '', dob : '', passport: {}, contact : {}, ff: {}, visa : {}, note : {}, credit: {}};
    const [user, setUser] = useState(templateUser);
    const [massage, setMassage] = useState({open: false, text: '', url: '', data: {}, fun: () => {}, agree: false, confirmed: false});
    const [disable, setDisable] = useState(false);
    const [page, setPage] = useState(1);

    function nameClick () {

        if (!disable && re('strEn', user.firstName) && re('strEn', user.lastName)) {
            setDisable(true);
        }
    }

    const handleKeyDown = (event) => {
        if (event.ctrlKey) {
            if (event.key === "Enter") {
                nameClick();
            } else if (event.key.startsWith('Arrow')) {
                let num = page;
                if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                    num += 4;
                } else if (event.key === "ArrowRight") {
                    num -= 1;
                } else if (event.key === "ArrowLeft") {
                    num += 1;
                }
                if (num > 8) {
                    num = num % 8;
                } else if (num === 0) {
                    num = 8;
                }
                setPage(num);
            }
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        }
    }, [page])

    useEffect(() => {
        if (numOfUser !== 0) {
            setUser(JSON.parse(JSON.stringify(names[numOfUser])));
            setDisable(true);
        } else {
            setDisable(false);
        }
    }, [numOfUser, names])

    function clickArrow (num) {
        /**  Move to the next name or to the previous name. */
        const keys = Object.keys(names);
        let num2 = keys.indexOf(numOfUser) + num;
        num2 = num2 >= keys.length ? 0 : num2 < 0 ? keys.length - 1 : num2;
        setNumOfUser(keys[num2]);
    }

    function AddUpdateUser (newUser) {
        if (disable && regx('strHe', user.fnh) && regx('strHe', user.lnh) && regx('^[0-9]{1,9}$', user.id) && user.firstName && user.lastName) {
            // update new user
            if (numOfUser === 0) {

                setMassage({text: "", open: true, url: "users/newUser", data: {...user, confirmed: massage.confirmed, num: numOfDocket || 0}, agree: false, confirmed: false,
                    fun: (resolve) => {
                        insertNewUser(resolve, setNames, () => setUser(newUser ? {...templateUser, lastName: user.lastName} : templateUser),user,
                        (text, alloed) => {
                            setMassage({open: true, text: text, url: '', data: {}, fun: () => {}, agree: alloed, confirmed: false});
                        })
                    }
                });

            // update old user
            } else { 
                const change = check_change(names[numOfUser], user);

                if (Object.keys(change).length > 1 || Object.values(change.data).length) {

                    setMassage({
                        text: "", open: true, url: "users/updateUser", data: {[numOfUser]: change}, agree: false,

                        fun: (resolve) => {
                            updateUser(resolve, user, names[numOfUser], numOfUser, setNames, setUser, (text) => {
                                setMassage({open: true, text: text, url: "", data: {}, fun: () => {}, agree: false})
                            })
                        }
                    })
                }
            }
        }
    }
    
    const deleteNamesFun = () => {
        if (numOfUser !== 0) {
            deleteNames({
                num: numOfUser,
                numOfDocket: numOfDocket,
                setMassage: (v) => setMassage({open: true, agree: false, confirmed: false, text: v}),
                deleteNames: deleteNamesInClient
            })
            setClose(false);
        } else {
            setUser(templateUser);
        }
    }

    const styleMy = {color: 'white'};
    
    return (<>
    <div className='new_name'>
        <div className='newNameHead'>
            {numOfUser && 
            <MdKeyboardDoubleArrowRight 
            className='icon-new-name'
            onClick={() => clickArrow(-1)}
            />}

            <p> {numOfUser ? `${user.firstName} ${user.lastName}` : 'הוסף לקוח חדש'} </p>

            {numOfUser &&
            <MdKeyboardDoubleArrowLeft 
            className='icon-new-name'
            onClick={() => clickArrow(1)}
            />
            }
        </div>

        <Close setClose={() => {setClose(false)}} />
        
        <Main 
        disable={disable}
        nameClick={() => nameClick()}
        data={user}
        setData={setUser}
        page={page}
        setPage={setPage}
        />

        <div className='newNameIcons'>
            <IconDiv 
            icon={"V"} 
            pStyle={styleMy} 
            className={'icon-2'} 
            text="הוסף \ עדכן"  
            onClick={() => {AddUpdateUser(false)}} 
            />
            <IconDiv 
            icon={"add"} 
            className={'icon-2'} 
            onClick={() => {AddUpdateUser(true)}} 
            />
            <IconDiv 
            icon={"search"} 
            className={'icon-2'} 
            onClick={() => setNamesSearch(user.firstName, user.lastName)}
            />
            <IconDiv 
            icon={"delete"} 
            className={'icon-2'} 
            onClick={deleteNamesFun}
            />
            <IconDiv 
            icon={"close"} 
            className={'icon-2'} 
            pIcon={{color: 'red'}} 
            onClick= {() => {setClose(false)}} 
            />
        </div>

        {
            massage.open && (massage.agree ? 
            <Massage 
            text={massage.text} 
            buttonAgree={() => setNamesSearch(user.firstName, user.lastName)} 
            setClose= {() => {setMassage({text: '', confirmed: true, agree: false, open: false})}} />
            : 
            <FetchMassage
            url={massage.url}
            data={massage.data}
            text={massage.text}
            setClose={() => setMassage({open: false, text: '', url: '', data: {}, fun: () => {}, agree: false, confirmed: false})}
            setMassage={setMassage}
            fun={massage.fun}
            />)
        }
        
    </div>
    </>)
}